/**
 * Modelo para eventos de tracking
 * Usado para rastrear eventos importantes en la aplicación
 */
export interface TrackerEvent {
    kind: 'PAYMENT' | 'CUSTOMER' | 'AUTH' | 'MERCHANT' | 'USER' | 'SYSTEM' | 'ERROR';
    source: 'MAINTAINER-UI';
    type: 'SUCCESS' | 'ERROR' | 'WARNING' | 'INFO';
    code: string;
    transactionId?: string;
    userId?: string;
    timestamp: string;
    data?: any;
}

/**
 * Tipos de códigos de eventos comunes
 */
export enum TrackerCode {
    // Auth Events
    AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS',
    AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR',
    AUTH_LOGOUT = 'AUTH_LOGOUT',
    AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED',
    AUTH_AD_LINK_ERROR = 'AUTH_AD_LINK_ERROR',
    
    // Payment Events
    PAYMENT_LIST_LOADED = 'PAYMENT_LIST_LOADED',
    PAYMENT_LIST_ERROR = 'PAYMENT_LIST_ERROR',
    PAYMENT_DETAIL_LOADED = 'PAYMENT_DETAIL_LOADED',
    PAYMENT_EXPORT_SUCCESS = 'PAYMENT_EXPORT_SUCCESS',
    PAYMENT_EXPORT_ERROR = 'PAYMENT_EXPORT_ERROR',
    
    // Merchant Events
    MERCHANT_CREATED = 'MERCHANT_CREATED',
    MERCHANT_UPDATED = 'MERCHANT_UPDATED',
    MERCHANT_ERROR = 'MERCHANT_ERROR',
    
    // User Events
    USER_CREATED = 'USER_CREATED',
    USER_UPDATED = 'USER_UPDATED',
    USER_ERROR = 'USER_ERROR',
    
    // System Events
    SYSTEM_ERROR = 'SYSTEM_ERROR',
    API_TIMEOUT = 'API_TIMEOUT',
    API_ERROR = 'API_ERROR',
    NETWORK_ERROR = 'NETWORK_ERROR',

    /** Tiempo desde shell listo hasta primera carga de pagos usable */
    SESSION_BOOTSTRAP_TTI = 'SESSION_BOOTSTRAP_TTI',
    /** Usuario eligió domain=ALL (carga potencialmente más lenta) */
    MERCHANT_ALL_SELECTED = 'MERCHANT_ALL_SELECTED',
}

